/**
* Take to shooping cart
*/
$('.btn:not(.cta, .btn--noScrollTo)').on('click', function (event) {
    $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
    }, 1000);
});